import { MapComponent } from 'src/app/components/map/map.component';

export class MeasuresAction {
	public static Exec(command: string, map: MapComponent, args?: any) {
		switch (command) {
			case 'feature-measures/area':
				break;
			case 'feature-measures/volume':
				break;
			case 'feature-measures/lenth':
				break;
			case 'free-hand-measures/area':
				break;
			case 'free-hand-measures/volume':
				break;
			case 'free-hand-measures/length':
				break;
		}
	}
	public static SetupButtons(map: MapComponent) {

	}
}